import * as React from 'react';
import './DashboardGraphList.scss';

interface DashboardGraphListProps {
  children: any;
}

const DashboardGraphList: React.FC<DashboardGraphListProps> = ({ children }) => {
  return <div className="DashboardGraphList">{children}</div>;
};

export default DashboardGraphList;
